module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_05 (1).485c1f6f.png";